import React from 'react';
import styled from 'styled-components';
// Components

import CitrinMobilityVision from '../../assets/img/citrinMobilityVision.jpg';
import DockStation from '../../assets/img/dockStation.png';

import { useTranslation } from 'react-i18next';

export default function Sustainablity() {
    const { t } = useTranslation();

    return (
        <Wrapper id="sustainablity">
            <div className="container">
                <HeaderInfo>
                    <br />
                    <h1 className="font40 extraBold">{t('titleSustainablity')}</h1>
                    <Text>
                        <p className="font18">
                            {t('textSustainablity1')}
                            <br />
                            {t('textSustainablity2')}
                            <br />
                            {t('textSustainablity3')}
                        </p>
                    </Text>
                </HeaderInfo>

                <div className="row flexCenter">
                    <ImgWrapper1 className="flexCenter">
                        <img src={CitrinMobilityVision} alt="netZero" className="radius6" />
                    </ImgWrapper1>
                </div>
            </div>

            <div className="lightBg">
                <div className="lightBg container">
                    <Inovation className="flexSpaceCenter">
                        <AddLeft>
                            <h2 className="font40"> {t('titleSolarEnergy')}</h2>
                            <h3 className="semiBold"> {t('titleInnovationenergySupply')}</h3>
                            <p className="font18">{t('textInnovationenergySupply')}</p>
                            <br />
                            <h3 className="semiBold"> {t('titleSharedResponsibility')}</h3>
                            <p className="font18">{t('textSharedResponsibility')}</p>
                        </AddLeft>
                        <AddRight>
                            <ImgWrapper2 className="flexCenter">
                                <img className="radius8" src={DockStation} alt="add" />
                            </ImgWrapper2>
                        </AddRight>
                    </Inovation>
                </div>
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    width: 100%;
    padding-top: 20px;
`;

const HeaderInfo = styled.div`
    margin-bottom: 45px;
    @media (max-width: 970px) {
        text-align: center;
    }
`;

const Inovation = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 80px 0;
    margin: 50px 0;
    gap: 40px;
    flex-wrap: wrap;

    @media (max-width: 1160px) {
        padding: 60px 0 40px 0;
    }
    @media (max-width: 860px) {
        flex-direction: column;
        padding: 0 0 30px 0;
        margin: 60px 0 0px 0;
    }
`;

const AddLeft = styled.div`
    flex: 1;
    min-width: 300px;
    p {
        max-width: 480px;
        margin-bottom: 20px;
        line-height: 1.6rem;
    }
    @media (max-width: 860px) {
        width: 90%;
        order: 2;
        text-align: center;
        h2 {
            line-height: 2.8rem;
            margin: 15px 0;
        }
        p {
            margin: 0 auto 20px;
        }
    }
`;

const AddRight = styled.div`
    flex: 1;
    min-width: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 860px) {
        width: 100%;
        order: 1;
    }
`;

const Text = styled.div`
    padding: 15px 0 50px 0;
    line-height: 1.7rem;
    max-width: 800px;

    @media (max-width: 970px) {
        padding: 15px 0 30px 0;
        text-align: center;
        max-width: 100%;
    }
`;

const ImgWrapper1 = styled.div`
    width: 100%;
    padding: 0 10%;
    margin-top: -30px;
    display: flex;
    justify-content: center;

    img {
        width: 100%;
        height: auto;
        border-radius: 8px;
    }

    @media (max-width: 768px) {
        padding: 0 5%;
        margin-top: 0;
    }
`;

const ImgWrapper2 = styled.div`
    width: 100%;
    max-width: 500px;
    img {
        width: 100%;
        height: auto;
    }

    @media (max-width: 460px) {
        padding: 20px 0;
        margin: 0 auto; /* centers the wrapper */
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
